var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TypographyBody, Stacker, TypographyHeading, Skeleton } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
import { interjectResourceString } from '../../../utils';
export function HotelFlightsSummaryHeading(_a) {
    var { totalFlights = 0, waitingForFlightAvailability = false } = _a, other = __rest(_a, ["totalFlights", "waitingForFlightAvailability"]);
    const { resourceStrings: { HOLIDAY_FLIGHTS_HEADING, HOLIDAY_FLIGHTS_SUBHEADING }, } = useGlobalContext();
    return (React.createElement(Stacker, Object.assign({ spacing: 2 }, other),
        React.createElement(TypographyHeading, { size: "s", color: "text.body", "data-id": "flight-summary-heading" }, HOLIDAY_FLIGHTS_HEADING),
        (waitingForFlightAvailability || totalFlights > 0) && (React.createElement(TypographyBody, { component: "div", size: "m", color: "text.light", "data-id": "flight-summary-sub-heading" },
            waitingForFlightAvailability && React.createElement(Skeleton, { variant: "text", w: "50%" }),
            !waitingForFlightAvailability &&
                totalFlights > 0 &&
                interjectResourceString(HOLIDAY_FLIGHTS_SUBHEADING, totalFlights)))));
}
